import React from 'react';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import {ProtectedRoute} from './components/ProtectedRoute';
import SuperProtectedRoute, { RubyProtectedRoute } from './components/SuperProtectedRoute';
import { CompActiveCheck, ActiveCheck } from './components/ActiveChecks';
import { useUser, UserProvider } from './components/UserContext';
import { GroupOrderProvider } from './components/GroupOrderContext';
import "./willowwebstyle.css";
import "./texteditstyle.css";
import NoPage from './pages/NoPage';
import Login from './pages/Login';
import Willowweb from './components/WillowHeader';
import Search, { loader as searchLoader } from './pages/Search';
import Page2, { pageLoader, profileLoader } from "./pages/page2";
import Manager, {loader as managerLoader } from './pages/Manager';
import People, {loader as peopleLoader } from './pages/People';
import Settings, {loader as settingsLoader } from './pages/Settings';
import CreateUser, {loader as createUserLoader} from './pages/CreateUser';
import ManageUsers, {loader as manageUserLoader} from './pages/ManageUsers';
import GroupViewer, {loader as groupViewerLoader} from './pages/GroupViewer';
import Payment, {loader as paymentLoader} from './pages/Payment';

const AppRouter = () => { //create wrappers to redirect not-paying users back to their profile
  const { currentUser } = useUser();
  const userId = currentUser ? Number(currentUser.id) : undefined;

  const router = createBrowserRouter([
    {
      path: "/",
      element: <ProtectedRoute element={<Willowweb />} />,
      errorElement: <NoPage />,
      children: [
        {
          errorElement: <NoPage />,
          children: [
            { index: true, element: <Navigate to={userId ? `/profile/${userId}` : "/login"} /> }, 
            {
              path: "/people/:userId",
              element: <SuperProtectedRoute currentUser={currentUser} element={<People />} />,
              loader: peopleLoader,
            },
            {
              path: "search",
              element: <ActiveCheck currentUser={currentUser} element={<Search />} />,
              loader: searchLoader,
            },
            {
              path: "profile/:userId",
              element: <CompActiveCheck currentUser={currentUser} element={<Page2 />} />,
              loader: profileLoader,
            },
            {
              path: "/:userId/page/:pageCode",
              element: <CompActiveCheck currentUser={currentUser} element={<Page2 />} />,
              loader: pageLoader,
            },
            {
              path: "/manage/:type/:userId",
              element: <SuperProtectedRoute currentUser={currentUser} element={<Manager />} />,
              loader: managerLoader,
            },
            {
              path: "/settings/:userId",
              element: <SuperProtectedRoute currentUser={currentUser} element={<Settings />} />,
              loader: settingsLoader,
            },
            {
              path: "/subscription/:userId",
              element: <SuperProtectedRoute currentUser={currentUser} element={<Payment />} />,
              loader: paymentLoader,
            },
            {
              path: "/createuser/:userId",
              element: <RubyProtectedRoute currentUser={currentUser} element={<CreateUser />} />,
              loader: createUserLoader,
            },
            {
              path: "/manageusers/:userId",
              element: <RubyProtectedRoute currentUser={currentUser} element={<ManageUsers />} />,
              loader: manageUserLoader,
            },
          ],
        },
      ],
    },
    {
      path: "/login",
      element: <Login />,
      errorElement: <NoPage />,
    },
    {
      path: "group/:groupLink",
      element: <GroupViewer />,
      loader: groupViewerLoader,
      errorElement: <NoPage />,
    },
  ]);

  return <RouterProvider router={router} />;
};

function App() {
  return (
    <UserProvider>
      <GroupOrderProvider>
        <AppRouter />
      </GroupOrderProvider>
    </UserProvider>
  );
}

export default App;